import { redirect } from "react-router-dom";
import { backendApi } from "./api";
import { User } from "./components/apiTypes";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { queryClient } from "./queryClient";

export function userQuery() {
  return queryOptions({
    queryKey: ["user"],
    queryFn: ({ signal }) =>
      backendApi<User>({ url: "/users/me", signal })
        .then((response) => response.data)
        .catch((error) => {
          // No need to panic on a 401 because it just means that no user
          // is logged in.
          if (error.response?.status === 401) return null;
          throw error;
        }),
    staleTime: 1000 * 60 * 5, // Expire after 5 minutes
  });
}

export function useUser() {
  return useQuery(userQuery()).data;
}

export function fetchUser() {
  return queryClient.fetchQuery(userQuery());
}

export async function requireUser() {
  const user = await fetchUser();
  if (!user) {
    localStorage.setItem(
      "next",
      window.location.pathname + window.location.search
    );
    throw redirect("/auth/login");
  }
  return user;
}

export function updateUser(data: Partial<User> | FormData) {
  return backendApi<User>({
    url: "/auth/user/",
    method: "PATCH",
    data,
  }).then((response) =>
    queryClient.setQueryData(userQuery().queryKey, response.data)
  );
}
